/* eslint-disable import/prefer-default-export */
export enum PointType {
    Credit = 'CREDIT',
    Debit = 'DEBIT',
    Chargeback = 'CHARGEBACK',
}
